import React from "react";

const Input_v2_bbred = (props) => {
  return (
    <input
    className="input_v2_bbred"
      type={props.type}
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder}
    />
  );
};

export default Input_v2_bbred;
